style= require('./create-new-user.styl')

.modal-header
  .modal-title='Create user'
  ft-icon.close(name='ui--cross', (click)= this.closeModal())

if user
  .row.user
    .col
      label= 'Email'
      p= user.email
    .col
      label= 'Password'
      p=  password
    .col
      label= 'User role'
      p=  user.role
  .footer
    button( (click)= this.closeModal()) Close
else
  form
    .row
      .col
        label Email
        input(
          type="email"
          name="email"
          required
          placeholder="john@johnny.jon")
      .col
        label User name
        input(
          type="text"
          name="username"
          placeholder=" New User name")
      .col
        label Role
        select(name="role")
          each role in ['user', 'moderator']
            option= role
    .footer
      button((click)=this.createUser()) Submit
